import * as React from 'react';
import {Stack} from '@mui/material';
import TemplateCard from './TemplateCard';
import TestEmailDialogForm from "./TestEmailDialogForm";
import {useTestTemplateMutation} from "../../../../services/templates";
import {toast} from "react-toastify";

type Props = {
  items: any[];
  onMenu: (id: string, anchor: HTMLElement) => void;
};

export default function TemplatesList({items, onMenu}: Props) {
  const [open, setOpen] = React.useState(false);
  const [currentId, setCurrentId] = React.useState<string | null>(null);

  const onTest = (id: string) => {
    setCurrentId(id);
    setOpen(true);
  }

  const onClose = () => {
    setOpen(false);
  }

  const [testTemplateApi] = useTestTemplateMutation();
  const handleSendTest = async (email: string) => {
    try {
      if (!currentId) {
        return;
      }
      await testTemplateApi({
        templateId: currentId,
        sourceEmailListId: "7695d570-2a21-438b-8767-751a1a9ad740",
        toEmail: email
      }).unwrap();
      toast.success("Test email sent successfully.");
      onClose();
      setCurrentId(null);
    } catch (e:any) {
      toast.error("Failed to send test email, please try again. error:"+e.getMessage());
      console.error("Test failed:", e);
    }

  }

  return (
    <>
      <Stack spacing={2}>
        {items.map((it) => (
          <TemplateCard key={it.id} item={it} onMenu={onMenu} onTest={onTest}/>
        ))}
      </Stack>
      <TestEmailDialogForm open={open} onClose={() => onClose()} onSend={handleSendTest}/>
    </>
  );
}
